import { render, staticRenderFns } from "./EvaluationCriterialMacroForm.vue?vue&type=template&id=55b8478c&scoped=true"
import script from "./EvaluationCriterialMacroForm.vue?vue&type=script&lang=js"
export * from "./EvaluationCriterialMacroForm.vue?vue&type=script&lang=js"
import style0 from "./EvaluationCriterialMacroForm.vue?vue&type=style&index=0&id=55b8478c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b8478c",
  null
  
)

export default component.exports